import { render, staticRenderFns } from "./AreasProtegidasEua.vue?vue&type=template&id=234814e8&lang=pug"
import script from "./AreasProtegidasEua.vue?vue&type=script&lang=js"
export * from "./AreasProtegidasEua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports